import { RESET_ASSIGNMENT_INFO } from '../../constants/types';

export function resetPopover() {
  return {
    type: RESET_ASSIGNMENT_INFO,
  };
}
